import { useContent } from "contexts/contentContext/contentContext";
import React from "react";
import Icon from "../Icon/Icon";
import Tooltip from "../Tooltip/Tooltip";
import "./InputElement.scss";

const InputElement = ({
  inputLabel,
  state,
  setState,
  isColumn,
  specificClass,
  inputTooltip,
  placeholder,
  icon,
  disabled = false,
  errorObject = null,
  isTextArea = false,
}) => {
  const { getTextByKey } = useContent();
  return (
    <div
      className={`input-elemet-container ${isColumn ? "is-column" : ""} ${
        specificClass ? specificClass : ""
      }`}
    >
      {inputLabel && (
        <span
          className={`input-element-label ${
            errorObject && errorObject.isShow ? "label-with-error-input" : ""
          }`}
        >
          {getTextByKey(inputLabel)}
        </span>
      )}
      {isTextArea ? (
        <div className="input-div-and-error textarea-input-div">
          <div className="input-div">
            <textarea
              placeholder={placeholder ? getTextByKey(placeholder) : ""}
              value={state}
              onChange={(e) => setState(e.target.value)}
              disabled={disabled}
            />
            {inputTooltip && (
              <div className="input-tooltip">
                <Tooltip
                  id={inputTooltip}
                  tooltipTextKey={inputTooltip}
                  top
                  mobileClickability
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>
            )}
            {icon && <div className="side-icon">{icon}</div>}
          </div>
          {errorObject && errorObject.isShow && (
            <span className="error-field-text">{errorObject.errorText}</span>
          )}
        </div>
      ) : (
        <div className="input-div-and-error">
          <div className="input-div">
            <input
              type="text"
              placeholder={placeholder ? getTextByKey(placeholder) : ""}
              value={state}
              onChange={(e) => setState(e.target.value)}
              disabled={disabled}
            />
            {inputTooltip && (
              <div className="input-tooltip">
                <Tooltip
                  id={inputTooltip}
                  tooltipTextKey={inputTooltip}
                  top
                  mobileClickability
                >
                  <Icon name="question-circle" iconClass="tooltip-question" />
                </Tooltip>
              </div>
            )}
            {icon && <div className="side-icon">{icon}</div>}
          </div>
          {errorObject && errorObject.isShow && (
            <span className="error-field-text">{errorObject.errorText}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default InputElement;
